import { render, staticRenderFns } from "./CreateImage.vue?vue&type=template&id=06f478c4&"
import script from "@/scripts/modal/rentalService/createImage.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/rentalService/createImage.js?vue&type=script&lang=js&"
import style0 from "./CreateImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports